module.exports = __webpack_public_path__ + "img/deyu_title_bg01.37f6ee47.png";